import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import MPPRegistrationsWidget from '../Stats/components/Registrations';
import MPPNumbersOfPlayersWidget from '../Stats/components/NumbersOfPlayers';
import MPPUsersByChampionshipWidget from '../Stats/components/UsersByChampionship';

const MPPDashboardStats = () => (
  <div id="league-MPP">
    <header className="content-header">
      <h1>
        Stats
        <small>MPP</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-trophy" /> MPP
        </li>
        <li className="text-bold">
          <Link to="/mpp">Dashboard</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <MPPRegistrationsWidget />
    </section>
    <section className="content">
      <div className="row">
        <div className="col-md-6">
          <MPPNumbersOfPlayersWidget />
        </div>
        <div className="col-md-6">
          <MPPUsersByChampionshipWidget />
        </div>
      </div>
    </section>
  </div>
);

export default connect(
  state => ({}),
  dispatch => ({dispatch}),
)(MPPDashboardStats);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/DashboardStats/index.tsx